import React from "react";
import "./data-table-card.css";

const DataTableCard = ({ data, isLoading = false }) => {
    const { title, count, columns, rows } = data;

    return (
        <div className="data-table-card">
            <div className="data-table-card-header d-flex justify-content-between align-items-center">
                <div className="data-table-card-title p-3">{title}</div>
                <div className="data-table-card-count d-flex justify-content-center align-items-center">
                    {!isLoading ? count : "-"}
                </div>
            </div>

            <div className="data-table-card-content">
                <div className="row data-table-card-columns g-0 p-3">
                    {columns.map((col, idx) => (
                        <div className="col text-center" key={idx}>
                            <span className="column-text">{col}</span>
                        </div>
                    ))}
                </div>

                <div className="p-3">
                    <div className="scroll-body">
                        {isLoading ? (
                            <div className="loading-container text-center d-flex flex-column gap-3">
                                <div className="skeleton" />
                                <div className="skeleton" />
                                <div className="skeleton" />
                            </div>
                        ) : rows.length > 0 ? (
                            rows.map((row, idx) => (
                                <div
                                    className="row data-table-card-row g-0 align-items-center px-0"
                                    key={idx}
                                >
                                    {row.map((cell, i) => (
                                        <div className="col text-center" key={i}>
                                            <span className={`cell-text ${cell?.className || ""}`}>
                                                {cell?.value}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-3 cell-text">
                                No hay datos disponibles
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataTableCard;
